module.exports = __webpack_public_path__ + "public/images/full-academic-courses.86ff88fcf610be513638416cd9827d57.png";